module.exports = __webpack_public_path__ + "static/img/partner-logo14.f23c5398.png";